import { memo, ReactElement, useMemo } from 'react'

import { useResponsive } from 'hooks/useResponsive'
import { SMALL_DESKTOP_SIZE_BREAKPOINT } from 'consts'

import TtsWebFlyoutWrapper from './Web'

import * as Styled from './styled'
import TtsFlyoutActionButtons from './ActionButtons'
import TtsMobileDrawer from './Mobile'
import { IButtonsConfig, ITtsFlyoutWrapperProps } from './types'
import { useTtsFlyoutVisibility } from './hooks'

const WrapperContent = ({
  children,
  buttonsConfig,
  isTooltipVisible,
  alertTooltipText
}: {
  children: ReactElement
  buttonsConfig?: IButtonsConfig
  isTooltipVisible?: boolean
  alertTooltipText?: string
}) => {
  return (
    <Styled.TtsContentWrapper>
      {children}
      {buttonsConfig && (
        <TtsFlyoutActionButtons
          buttonsConfig={buttonsConfig}
          isTooltipVisible={isTooltipVisible}
          alertTooltipText={alertTooltipText}
        />
      )}
    </Styled.TtsContentWrapper>
  )
}

const TtsFlyout: React.FC<ITtsFlyoutWrapperProps> = (
  props: ITtsFlyoutWrapperProps
) => {
  const {
    togglerElement,
    children,
    buttonsConfig,
    onClose,
    isOpen,
    width,
    height,
    hasAlertTooltip = false,
    alertTooltipText,
    ignoredClassNames,
    scrollableContainerRef
  } = props

  const isTablet = useResponsive(SMALL_DESKTOP_SIZE_BREAKPOINT)
  const { handleClose, isAlertTooltipVisible } = useTtsFlyoutVisibility(
    onClose,
    hasAlertTooltip,
    scrollableContainerRef
  )

  const content = useMemo(() => {
    return (
      <WrapperContent
        buttonsConfig={buttonsConfig}
        isTooltipVisible={isAlertTooltipVisible}
        alertTooltipText={alertTooltipText}
      >
        {children}
      </WrapperContent>
    )
  }, [children, buttonsConfig, alertTooltipText, isAlertTooltipVisible])

  if (isTablet) {
    return (
      <TtsMobileDrawer
        content={content}
        onClose={handleClose}
        isOpen={isOpen}
      />
    )
  }

  return (
    <TtsWebFlyoutWrapper
      content={content}
      onClose={handleClose}
      isOpen={isOpen}
      togglerElement={togglerElement}
      width={width}
      height={height}
      ignoredClassNames={ignoredClassNames}
      hasAlertTooltip={hasAlertTooltip}
    >
      {children}
    </TtsWebFlyoutWrapper>
  )
}
export default memo(TtsFlyout)
